import { Accordion } from '../../../../../components/general/accordion';
import AttachmentIcon from '@mui/icons-material/Attachment';
import { Table } from '../../../../../components/general/table';
import { useLegalProceedingsAttachment } from './hook';
import { LegalProceedingsAttachmentProps } from './props';

export const LegalProceedingsAttachment = (
    props: LegalProceedingsAttachmentProps
) => {
    const { columns, rows } = useLegalProceedingsAttachment(props);

    return (
        <Accordion
            title="ARCHIVOS ADJUNTOS"
            icon={<AttachmentIcon sx={{ color: 'primary.main' }} />}
            defaultExpanded={false}
            mt={0}
        >
            <Table
                columns={columns}
                rows={rows}
                rowCount={rows.length}
                pageSizeOptions={[10, 20, 50]}
                disableRowSelectionOnClick
            />
        </Accordion>
    );
};
